import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { mapDto } from '@shared/operators';
import { ProfileStatistics, ProfileStatisticsDto } from '../models';

@Injectable({
    providedIn: 'root',
})
export class ProfileStatisticsHttpService {
    private httpClient = inject(HttpClient);

    getProfileStatistics() {
        return this.httpClient.get<ProfileStatisticsDto>('profile/statistic').pipe(mapDto((response) => new ProfileStatistics(response)));
    }
}
